<template lang="pug">
#docContainer(v-loading="loading", element-loading-text="图片加载中...", element-loading-background="rgba(0, 0, 0, 0.5)")
  .image(ref="image")
    preview-img(ref="bigImage", :imgUrl="imageUrl")
  application(ref="docApplication", type="image", v-if="docloaded")
</template>

<script>
import { scanUrl, creatWatermarkUserInfo, addWaterMarker } from "@/CommonDP/mongeView/utils";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import application from "@/CommonDP/mongeView/application.vue";
import previewImg from "@/CommonDP/components/previewImg/index.vue";

export default {
  components: { application, previewImg },
  data() {
    return {
      inputText: "",
      loading: true,
      imageUrl: "",
      docloaded: false
    };
  },
  computed: {
    docmentData() {
      return JSON.parse(mongeApp.other.fileInfo);
    }
  },
  created() {
    this.getFileInfo();
  },
  methods: {
    async getFileInfo() {
      const { fileId, versionId: fileVersion, sharerId = "", i = "" } = this.$route.query;
      mongeMutations.setShareId(i);
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const { data } = await mongeService.getFileDetails(fileId, i);
      document.title = data.fileName;
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion
      };
      mongeMutations.setDocmentView(JSON.stringify(urlData));
      await this.getRequestData(sharerId);
    },
    getRequestData(sharerId) {
      const otherData = this.docmentData;
      this.imageUrl = scanUrl(otherData.fileId, otherData.fileVersion, sharerId);
      addWaterMarker(document.body, creatWatermarkUserInfo());
      this.loading = false;
      this.docloaded = true;
    }
  }
};
</script>
<style lang="scss" scoped>
#docContainer {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  .image {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    overflow-y: auto;
  }
  .imageLoading {
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
